<template>
  <div class="rules">
    <rules-table></rules-table>
  </div>
</template>

<script>
import RulesTable from "../components/RulesTable.vue";

export default {
  name: "RulesView",
  components: {
    RulesTable,
  },
};
</script>
